module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom","umd":"react-dom"}
// module id = 15
// module chunks = 0 1